import React from 'react';
import PropTypes from 'prop-types';
import { sizes } from '../../theme/breakpoint';
import { LogoStyled, LogoWrapper } from './styles';

/**
 * A container for the logo, switching between
 * different resolutions for mobile/desktop
 */
export const Logo = ({ logo, logoMobile }) => {
  // Fallback for if logo in Site Config is not set.
  const logoMobileSafe = logoMobile || logo;

  return (
    <LogoStyled>
      <source
        media={`(min-width: ${sizes.desktop}px)`}
        srcSet={logo.file.url}
      />
      <source srcSet={logoMobileSafe.file.url} />
      <img src={logo.file.url} alt="Shelter Logo" />
    </LogoStyled>
  );
};

Logo.propTypes = {
  logo: PropTypes.object.isRequired,
  logoMobile: PropTypes.object,
};

// re-export logo wrapper here to allow single line import elsewhere
export { LogoWrapper };
